import { Card, Form, Input, Space } from '@pankod/refine-antd';

export const AddressFormItem: React.FC = () => {
  return (
    <Card title="Address">
      <Space align="center" size="large" style={{ display: 'flex', flexWrap: 'wrap' }}>
        <Form.Item label="Street" name={['address', 'street']}>
          <Input />
        </Form.Item>
        <Form.Item label="Area" name={['address', 'area']}>
          <Input />
        </Form.Item>
      </Space>
      <Space align="center" size="large" style={{ display: 'flex', flexWrap: 'wrap' }}>
        <Form.Item label="City" name={['address', 'city']}>
          <Input />
        </Form.Item>
        <Form.Item label="Country" name={['address', 'country']}>
          <Input />
        </Form.Item>
      </Space>
      <Space align="center" size="large" style={{ display: 'flex' }}>
        <Form.Item label="Zip" name={['address', 'zip']}>
          <Input />
        </Form.Item>
      </Space>
    </Card>
  );
};
